import { useLocation } from "react-router-dom"

export const useFullUrl = (): string => {
    const location = useLocation(),
        fullUrlVisited: string = decodeURIComponent(`${location.pathname}${location.search}`).replaceAll("&amp;", "&");

    return fullUrlVisited;
}

export const useSearchUrl = (): string => {
    const location = useLocation(),
        result = decodeURI(location.search).replaceAll("&amp;", "&");

    return result;
}